import { gql } from "@apollo/client";
import {
  LEARNER_ONBOARDING_PARTS,
  LEARNER_PARTS,
  LEARNER_ARTICLE_PARTS,
  LEARNER_PRACTITIONER_PARTS,
  LEARNER_RECORDING_PARTS,
  LEARNER_GROUP_SESSION_PARTS,
  LEARNER_PROFILE_PARTS,
  LEARNER_PROFILE_SETTINGS_PARTS,
  BOOLEAN_INPUT_PARTS,
  LEARNER_INDEX_BREAK_DOWN_PILLAR_PARTS,
  LEARNER_SESSION_CARD_PARTS,
  LEARNER_BIOMETRICS_PARTS,
  LEARNER_INDEX_CTA_PARTS,
  LEARNER_INDEX_SCORE_CHANGE_PARTS,
  LEARNER_INDEX_SCORE_GRAPH_PARTS,
  LEARNER_INDEX_BREAK_DOWN_PILLAR_V2_PARTS,
  ASSESSMENT_SCHEDULE_PARTS,
} from "./fragment";

//USER_SESSION_LINK FOR 1-CLICK SESSION
export const USER_SESSION_LINK = gql`
  mutation UserSessionLink($input: UserSessionLinkInput!) {
    userSessionLink(input: $input) {
      ok
      user {
        id
        email
      }
      privateSession {
        id
        joiningLink
        startDateTime
        endDateTime
        classObj {
          name
          description
        }
        classType {
          name
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            photo
            userObj {
              firstName
              lastName
            }
          }
        }
        student {
          id
          userdetailObj {
            photo
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
      groupSessionInstance {
        id
        joiningLink
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        instanceDisplayEndDateTime
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              firstName
              lastName
              id
            }
          }
        }
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          name
          photo
          id
          description
          preparationMaterial
          classObj {
            name
            description
          }
          classType {
            name
          }
          day
          groupSessionFor
          corporateCompany {
            name
          }
        }
      }
    }
  }
`;

//UNREGISTER_FOR_GROUP_SESSION
export const UNREGISTER_FOR_GROUP_SESSION = gql`
  mutation UnRegisterForGroupSession($input: RegisterForGroupSessionInput!) {
    unRegisterForGroupSession(input: $input) {
      groupSessionPersonLeft {
        user {
          firstName
          lastName
        }
        groupSessionInstance {
          instanceDisplayEndDateTime
          instanceStartDateTime
          instanceEndDateTime
        }
      }
    }
  }
`;

//REGISTER_FOR_GROUP_SESSION
export const REGISTER_FOR_GROUP_SESSION = gql`
  mutation RegisterForGroupSession($input: RegisterForGroupSessionInput!) {
    registerForGroupSession(input: $input) {
      groupSessionPersonJoined {
        id
        groupSessionInstance {
          instanceDisplayEndDateTime
          instanceStartDateTime
          instanceEndDateTime
        }
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

//JOIN_OUR_COMMUNITY
export const JOIN_OUR_COMMUNITY = gql`
  query JoinOurCommunity($roleName: String!) {
    joinOurCommunity(roleName: $roleName) {
      communitySessionToday {
        id
        instanceDisplayEndDateTime
        instanceStartDateTime
        instanceEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classObj {
            description
            name
          }
          classType {
            name
          }
          preparationMaterial
        }
        joiningLink
        studentfeedbackbyteacherSet {
          id
          title
          notes
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
      communitySessionThisWeek {
        id
        instanceDisplayEndDateTime
        instanceStartDateTime
        instanceEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classObj {
            description
            name
          }
          classType {
            name
          }
          preparationMaterial
        }
        joiningLink
        studentfeedbackbyteacherSet {
          id
          title
          notes
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              firstName
              lastName
              id
            }
          }
        }
      }
    }
  }
`;

//QUERY_TEACHERSESSIONDETAILTODAY
export const QUERY_TEACHERSESSIONDETAILTODAY = gql`
  query UserSessionsToday($roleName: String!, $tz: String!) {
    userSessionsToday(roleName: $roleName, tz: $tz) {
      ... on ClassSessionType {
        id
        day
        startDateTime
        endDateTime
        joiningLink
        studentfeedbackbyteacherSet {
          id
          title
          notes
        }
        classType {
          name
        }
        classObj {
          id
          name
          description
          service {
            id
            name
          }
        }
        teacher {
          id
          landscapePhoto
        }
        student {
          id
          userdetailObj {
            photo
            userObj {
              firstName
              lastName
            }
          }
        }
      }

      ... on GroupSessionInstanceType {
        id
        isLeadingTheSession
        instanceDisplayEndDateTime
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        studentfeedbackbyteacherSet {
          id
          title
          notes
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              firstName
              lastName
              id
            }
          }
        }
        groupSession {
          id
          groupSessionFor
          photo
          name
          displayEndTime
          preparationMaterial
          classType {
            name
          }
          description
          corporateCompany {
            name
          }
          classObj {
            name
            description
          }
        }
        joiningLink
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

//QUERY_TEACHERSESSIONDETAILWEEK
export const QUERY_TEACHERSESSIONDETAILWEEK = gql`
  query UserSessionsThisWeek($roleName: String!, $tz: String!) {
    userSessionsThisWeek(roleName: $roleName, tz: $tz) {
      ... on ClassSessionType {
        id
        day
        startDateTime
        endDateTime
        joiningLink
        studentfeedbackbyteacherSet {
          id
          title
          notes
        }
        classType {
          name
        }
        classObj {
          id
          name
          description
          service {
            id
            name
          }
        }
        teacher {
          id
          landscapePhoto
        }
        student {
          id
          userdetailObj {
            photo
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }

      ... on GroupSessionInstanceType {
        id
        isLeadingTheSession
        instanceDisplayEndDateTime
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        studentfeedbackbyteacherSet {
          id
          title
          notes
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
        groupSession {
          id
          groupSessionFor
          photo
          name
          displayEndTime
          classType {
            name
          }
          description
          corporateCompany {
            name
          }
          classObj {
            name
            description
          }
          preparationMaterial
        }
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
//QUERY_CREATEACCESSTOKEN
export const QUERY_CREATEACCESSTOKEN = gql`
  mutation CreateAccessToken($input: AccessTokenInput!) {
    createAccessToken(input: $input) {
      agoraDetail {
        channelName
        resourceId
        sid
        uid
      }
      rtcTokenWithUid
      ok
    }
  }
`;

//UPDATE_CLASSSESSION
export const UPDATE_CLASSSESSION = gql`
  mutation updateClassSession($id: ID!, $input: ClassSessionUpdateInput!) {
    updateClassSession(id: $id, input: $input) {
      ok
      classSession {
        id
        sessionJoiningPlatform
        classObj {
          id
          name
        }
      }
    }
  }
`;
//QUERY_FEEDBACKBYSTUDENTID
export const QUERY_FEEDBACKBYSTUDENTID = gql`
  query feedbackByStudentId($id: ID!) {
    feedbackByStudentId(id: $id) {
      id
      notes
      title
      updatedAt
      teacher {
        userdetailObj {
          photo
          userObj {
            firstName
            lastName
          }
        }
      }
      session {
        classObj {
          name
        }
        classType {
          name
        }
      }
    }
  }
`;

//CREATE_SESSION
export const CREATE_SESSION = gql`
  mutation CreateClassSession($input: ClassSessionCreateInput!) {
    createClassSession(input: $input) {
      classSession {
        id
        classObj {
          id
          name
        }
        classType {
          id
          name
        }
        teacher {
          userdetailObj {
            userObj {
              firstName
              lastName
            }
          }
        }
        student {
          userdetailObj {
            userObj {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

//QUERY_SESSIONDETAILWEEK
export const QUERY_SESSIONDETAILWEEK = gql`
  query UserSessionsThisWeek($roleName: String!, $tz: String!) {
    userSessionsThisWeek(roleName: $roleName, tz: $tz) {
      ... on ClassSessionType {
        id
        day
        startDateTime
        endDateTime
        joiningLink
        classType {
          name
        }
        classObj {
          id
          name
          description
          service {
            id
            name
          }
        }
        student {
          id
          userdetailObj {
            photo
            userObj {
              firstName
              lastName
            }
          }
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            photo
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }

      ... on GroupSessionInstanceType {
        id
        instanceDisplayEndDateTime
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        teacher {
          id
          landscapePhoto
          userdetailObj {
            photo
            userObj {
              firstName
              lastName
            }
          }
        }
        groupSession {
          id
          groupSessionFor
          photo
          name
          displayEndTime
          classType {
            name
          }
          description
          corporateCompany {
            name
          }
          classObj {
            name
            description
          }
          preparationMaterial
        }
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
//QUERY_SESSIONDETAILTODAY
export const QUERY_SESSIONDETAILTODAY = gql`
  query UserSessionsToday($roleName: String!, $tz: String!) {
    userSessionsToday(roleName: $roleName, tz: $tz) {
      ... on ClassSessionType {
        id
        day
        startDateTime
        endDateTime
        joiningLink
        classType {
          name
        }
        classObj {
          id
          photo
          name
          description
          service {
            id
            name
          }
        }
        student {
          id
          userdetailObj {
            photo
            userObj {
              id
              firstName
              lastName
            }
          }
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            photo
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }

      ... on GroupSessionInstanceType {
        id
        instanceDisplayEndDateTime
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        teacher {
          id
          landscapePhoto
          userdetailObj {
            photo
            userObj {
              id
              firstName
              lastName
            }
          }
        }

        groupSession {
          groupSessionFor
          photo
          preparationMaterial
          day
          id
          name
          displayEndTime
          classType {
            name
          }
          description
          corporateCompany {
            name
          }
          classObj {
            name
            description
          }
        }
        joiningLink
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

//TEACHERS_FEEDBACK_BY_STUDENT
export const TEACHERS_FEEDBACK_BY_STUDENT = gql`
  mutation CreateUpdateSessionFeedback(
    $input: CreateUpdateSessionFeedbackInput!
  ) {
    createUpdateSessionFeedback(input: $input) {
      ok
      sessionFeedback {
        id
        privateSession {
          id
        }
        groupSessionInstance {
          id
        }
        user {
          username
        }
        notes
        teacherCharacteristics {
          id
        }
      }
    }
  }
`;
//STUDENTS_FEEDBACK_BY_TEACHER
export const STUDENTS_FEEDBACK_BY_TEACHER = gql`
  mutation CreateUpdateTeacherSessionNotes(
    $input: CreateUpdateTeacherSessionNotesInput!
  ) {
    createUpdateTeacherSessionNotes(input: $input) {
      ok
      sessionNotes {
        id
        privateSession {
          id
        }
        groupSessionInstance {
          id
        }
        title
        notes
      }
    }
  }
`;

export const USER_JOINED_GROUP_SESSION = gql`
  mutation UserJoinedGroupSession($input: UserJoinedGroupSessionInput!) {
    userJoinedGroupSession(input: $input) {
      ok
    }
  }
`;

export const CREATE_ONBOARDING = gql`
  mutation LearnerOnboarding(
    $appInfo: AppInfo!
    $input: LearnerOnboardingInput!
  ) {
    learnerOnboarding(appInfo: $appInfo, input: $input) {
      ok
      learner {
        ...LearnerParts
        onboarding {
          ...LearnerOnboardingParts
        }
        biometrics {
          ...LearnerBiometricsParts
        }
        screens {
          index {
            version
          }
        }
      }
      welcomeScreen {
        titleHtml
        subtitleHtml
        buttonText
      }
    }
  }
  ${LEARNER_PARTS}
  ${LEARNER_ONBOARDING_PARTS}
  ${LEARNER_BIOMETRICS_PARTS}
`;

export const REPORT_ARTICLE_OPEN = gql`
  mutation ReportArticleOpen(
    $articleId: ID!
    $at: String!
    $platform: String!
    $appInfo: AppInfo!
  ) {
    reportArticleOpen(
      articleId: $articleId
      at: $at
      platform: $platform
      appInfo: $appInfo
    ) {
      ok
      groupUuid
    }
  }
`;

export const REPORT_ARTICLE_SCROLL_START = gql`
  mutation ReportArticleScrollStart(
    $articleId: ID!
    $at: String!
    $platform: String!
    $groupUuid: ID!
    $appInfo: AppInfo!
  ) {
    reportArticleScrollStart(
      articleId: $articleId
      at: $at
      platform: $platform
      groupUuid: $groupUuid
      appInfo: $appInfo
    ) {
      ok
    }
  }
`;

export const REPORT_ARTICLE_SCROLL_PROGRESS = gql`
  mutation ReportArticleScrollProgress(
    $articleId: ID!
    $at: String!
    $platform: String!
    $groupUuid: ID!
    $percentage: Int!
    $appInfo: AppInfo!
  ) {
    reportArticleScrollProgress(
      articleId: $articleId
      at: $at
      platform: $platform
      groupUuid: $groupUuid
      percentage: $percentage
      appInfo: $appInfo
    ) {
      ok
    }
  }
`;

export const REPORT_ARTICLE_SCROLL_END = gql`
  mutation ReportArticleScrollEnd(
    $articleId: ID!
    $at: String!
    $platform: String!
    $groupUuid: ID!
    $appInfo: AppInfo!
  ) {
    reportArticleScrollEnd(
      articleId: $articleId
      at: $at
      platform: $platform
      groupUuid: $groupUuid
      appInfo: $appInfo
    ) {
      ok
    }
  }
`;

export const REPORT_RECORDING_OPEN = gql`
  mutation ReportRecordingOpen(
    $recordingId: ID!
    $at: String!
    $platform: String!
    $appInfo: AppInfo!
  ) {
    reportRecordingOpen(
      recordingId: $recordingId
      at: $at
      platform: $platform
      appInfo: $appInfo
    ) {
      ok
      groupUuid
    }
  }
`;

export const REPORT_RECORDING_VIDEO_START = gql`
  mutation ReportRecordingVideoStart(
    $recordingId: ID!
    $at: String!
    $platform: String!
    $groupUuid: ID!
    $appInfo: AppInfo!
  ) {
    reportRecordingVideoStart(
      recordingId: $recordingId
      at: $at
      platform: $platform
      groupUuid: $groupUuid
      appInfo: $appInfo
    ) {
      ok
    }
  }
`;

export const REPORT_RECORDING_VIDEO_PROGRESS = gql`
  mutation ReportRecordingVideoProgress(
    $recordingId: ID!
    $at: String!
    $platform: String!
    $groupUuid: ID!
    $percentage: Int!
    $duration: Int!
    $currentTime: Int!
    $appInfo: AppInfo!
  ) {
    reportRecordingVideoProgress(
      recordingId: $recordingId
      at: $at
      platform: $platform
      groupUuid: $groupUuid
      percentage: $percentage
      duration: $duration
      currentTime: $currentTime
      appInfo: $appInfo
    ) {
      ok
    }
  }
`;

export const REPORT_RECORDING_VIDEO_END = gql`
  mutation ReportRecordingVideoEnd(
    $recordingId: ID!
    $at: String!
    $platform: String!
    $groupUuid: ID!
    $appInfo: AppInfo!
  ) {
    reportRecordingVideoEnd(
      recordingId: $recordingId
      at: $at
      platform: $platform
      groupUuid: $groupUuid
      appInfo: $appInfo
    ) {
      ok
    }
  }
`;

export const QUERY_UPDATE_CORPORATE_ADMIN = gql`
  mutation UpdateStudentdetail($id: ID!, $input: StudentDetailUpdateInput!) {
    updateStudentdetail(id: $id, input: $input) {
      studentDetail {
        id
        userdetailObj {
          userObj {
            id
            firstName
            lastName
            email
            username
          }
        }
      }
      ok
    }
  }
`;

export const LEARNER_FAVOURITE = gql`
  mutation LearnerFavourite($id: ID!, $typename: String!, $appInfo: AppInfo!) {
    learnerFavourite(id: $id, typename: $typename, appInfo: $appInfo) {
      ok
      item {
        __typename
        ... on LearnerArticle {
          ...LearnerArticleParts
        }
        ... on LearnerRecording {
          ...LearnerRecordingParts
        }
        ... on LearnerPractitioner {
          ...LearnerPractitionerParts
        }
      }
    }
  }
  ${LEARNER_ARTICLE_PARTS}
  ${LEARNER_RECORDING_PARTS}
  ${LEARNER_PRACTITIONER_PARTS}
`;

export const LEARNER_UN_FAVOURITE = gql`
  mutation LearnerUnFavourite(
    $id: ID!
    $typename: String!
    $appInfo: AppInfo!
  ) {
    learnerUnFavourite(id: $id, typename: $typename, appInfo: $appInfo) {
      ok
      item {
        __typename
        ... on LearnerArticle {
          ...LearnerArticleParts
        }
        ... on LearnerRecording {
          ...LearnerRecordingParts
        }
        ... on LearnerPractitioner {
          ...LearnerPractitionerParts
        }
      }
    }
  }
  ${LEARNER_ARTICLE_PARTS}
  ${LEARNER_RECORDING_PARTS}
  ${LEARNER_PRACTITIONER_PARTS}
`;

export const LEARNER_REGISTER_FOR_GROUP_SESSION = gql`
  mutation LearnerRegisterForGroupSession(
    $id: ID!
    $appInfo: AppInfo!
    $utmParameters: UTMParametersInput
  ) {
    learnerRegisterForGroupSession(
      id: $id
      appInfo: $appInfo
      utmParameters: $utmParameters
    ) {
      ok
      learnerGroupSession {
        ...LearnerGroupSessionParts
      }
    }
  }
  ${LEARNER_GROUP_SESSION_PARTS}
`;

export const LEARNER_UNREGISTER_FOR_GROUP_SESSION = gql`
  mutation LearnerUnRegisterForGroupSession($id: ID!, $appInfo: AppInfo!) {
    learnerUnRegisterForGroupSession(id: $id, appInfo: $appInfo) {
      ok
      learnerGroupSession {
        ...LearnerGroupSessionParts
      }
    }
  }
  ${LEARNER_GROUP_SESSION_PARTS}
`;

export const LEARNER_JOIN_GROUP_SESSION = gql`
  mutation LearnerJoinGroupSession(
    $appInfo: AppInfo!
    $id: ID!
    $utmParameters: UTMParametersInput
  ) {
    learnerJoinGroupSession(
      appInfo: $appInfo
      id: $id
      utmParameters: $utmParameters
    ) {
      ok
      learnerBeforeJoiningGroupSessionFeedbackForm {
        biometricsBubble {
          title
          contentHtml
        }
      }
      learnerBeforeGroupSessionFeedbackForm {
        biometricsBubble {
          title
          contentHtml
        }
        messages {
          title
          senderAvatarUrl
          senderName
          textHtml
          input {
            __typename
            ... on RangeInput {
              id
              label
              required
              min
              minLabel
              max
              maxLabel
              step
            }
            ... on TextInput {
              id
              label
              required
              minLength
              maxLength
              placeholder
            }
            ... on SelectInput {
              id
              label
              required
              options {
                label
                value
              }
            }
          }
          buttonText
        }
      }
      zoomMtgNumber
      zoomMtgPassWord
      zoomMtgSignature
    }
  }
`;

export const LEARNER_SUBMIT_BEFORE_GROUP_SESSION_FEEDBACK = gql`
  mutation LearnerSubmitBeforeGroupSessionFeedback(
    $appInfo: AppInfo!
    $groupSessionId: ID!
    $type: String!
    $input: [LearnerGroupSessionFeedbackInput]!
  ) {
    learnerSubmitBeforeGroupSessionFeedback(
      appInfo: $appInfo
      groupSessionId: $groupSessionId
      type: $type
      input: $input
    ) {
      ok
    }
  }
`;

export const LEARNER_SUBMIT_AFTER_GROUP_SESSION_FEEDBACK = gql`
  mutation LearnerSubmitAfterGroupSessionFeedback(
    $appInfo: AppInfo!
    $groupSessionId: ID!
    $type: String!
    $input: [LearnerGroupSessionFeedbackInput]!
  ) {
    learnerSubmitAfterGroupSessionFeedback(
      appInfo: $appInfo
      groupSessionId: $groupSessionId
      type: $type
      input: $input
    ) {
      ok
    }
  }
`;

export const LEARNER_UPDATE_HOURS_PER_WEEK = gql`
  mutation LearnerUpdateHoursPerWeek($appInfo: AppInfo!, $value: Int!) {
    learnerUpdateHoursPerWeek(appInfo: $appInfo, value: $value) {
      ok
      learner {
        id
        firstName
        lastName
        fullName
        photoUrl
        screens {
          profile {
            ...LearnerProfileParts
          }
        }
      }
    }
  }
  ${LEARNER_PROFILE_PARTS}
`;

export const LEARNER_UPDATE_LANGUAGE = gql`
  mutation LearnerUpdateLanguage(
    $language: String!
    $explicit: Boolean
    $appInfo: AppInfo!
  ) {
    learnerUpdateLanguage(
      language: $language
      explicit: $explicit
      appInfo: $appInfo
    ) {
      ok
      learner {
        id
        language
        languageIsExplicit
      }
    }
  }
`;

export const LEARNER_UPDATE_PROFILE_SETTINGS = gql`
  mutation LearnerUpdateProfileSettings(
    $input: LearnerUpdateProfileSettingsInput!
    $appInfo: AppInfo!
  ) {
    learnerUpdateProfileSettings(appInfo: $appInfo, input: $input) {
      __typename
      ok
      learner {
        __typename
        id
        firstName
        lastName
        fullName
        photoUrl
        screens {
          __typename
          profile {
            __typename
            settings {
              __typename
              title
              profile {
                __typename
                ...LearnerProfileSettingsParts
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_PROFILE_SETTINGS_PARTS}
`;

export const LEARNER_UPDATE_NOTIFICATION_SETTINGS_TOGGLE = gql`
  mutation LearnerUpdateNotificationSettingsToggle(
    $id: ID!
    $checked: Boolean!
    $appInfo: AppInfo!
  ) {
    learnerUpdateNotificationSettingsToggle(
      id: $id
      checked: $checked
      appInfo: $appInfo
    ) {
      learner {
        id
        screens {
          profile {
            settings {
              notifications {
                toggles {
                  ...BooleanInputParts
                }
              }
            }
          }
        }
      }
    }
  }
  ${BOOLEAN_INPUT_PARTS}
`;

export const SET_OWN_FEATURE_FLAG = gql`
  mutation SetOwnFeatureFlag($name: String!, $enabled: Boolean!) {
    setOwnFeatureFlag(name: $name, enabled: $enabled) {
      ok
      flags {
        name
        enabled
      }
    }
  }
`;

export const LEARNER_UPDATE_CALENDAR_SETTINGS_TOGGLE = gql`
  mutation LearnerUpdateCalendarSettingsToggle(
    $id: ID!
    $checked: Boolean!
    $appInfo: AppInfo!
  ) {
    learnerUpdateCalendarSettingsToggle(
      id: $id
      checked: $checked
      appInfo: $appInfo
    ) {
      __typename
      ok
      learner {
        __typename
        id
        screens {
          __typename
          profile {
            __typename
            settings {
              __typename
              calendar {
                __typename
                toggles {
                  __typename
                  ...BooleanInputParts
                }
              }
            }
          }
        }
      }
    }
  }
  ${BOOLEAN_INPUT_PARTS}
`;

export const LEARNER_BIOMETRICS_DISCONNECT_PROVIDER = gql`
  mutation LearnerBiometricsDisconnectProvider($id: ID!, $appInfo: AppInfo!) {
    learnerBiometricsDisconnectProvider(id: $id, appInfo: $appInfo) {
      ok
      learner {
        __typename
        id
        biometrics {
          hasHealthData
        }
        screens {
          profile {
            settings {
              biometrics {
                providers {
                  title
                  providers {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const LEARNER_BIOMETRICS_DELETE_HEALTH_DATA = gql`
  mutation LearnerBiometricsDeleteHealthData($appInfo: AppInfo!) {
    learnerBiometricsDeleteHealthData(appInfo: $appInfo) {
      ok
      learner {
        __typename
        id
        biometrics {
          hasHealthData
        }
        screens {
          profile {
            settings {
              biometrics {
                providers {
                  title
                  providers {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const LEARNER_BIOMETRICS_MODAL_DONT_ASK_AGAIN = gql`
  mutation LearnerBiometricsModalDontAskAgain($appInfo: AppInfo!) {
    learnerBiometricsModalDontAskAgain(appInfo: $appInfo) {
      learner {
        id
        biometrics {
          modal {
            title
            contentHtml
            tellMeMoreButtonText
            remindMeLaterButtonText
          }
        }
      }
    }
  }
`;

export const LEARNER_BIOMETRICS_MODAL_TELL_ME_MORE = gql`
  mutation LearnerBiometricsModalTellMeMore($appInfo: AppInfo!) {
    learnerBiometricsModalTellMeMore(appInfo: $appInfo) {
      learner {
        id
        biometrics {
          modal {
            title
            contentHtml
            tellMeMoreButtonText
            remindMeLaterButtonText
          }
        }
      }
    }
  }
`;

export const LEARNER_BIOMETRICS_MODAL_REMIND_ME_LATER = gql`
  mutation LearnerBiometricsModalRemindMeLater($appInfo: AppInfo!) {
    learnerBiometricsModalRemindMeLater(appInfo: $appInfo) {
      learner {
        id
        biometrics {
          modal {
            title
            contentHtml
            tellMeMoreButtonText
            remindMeLaterButtonText
          }
        }
      }
    }
  }
`;

export const TRIGGER_LEARNER_VERIFICATION_EMAIL = gql`
  mutation TriggerLearnerVerificationEmail(
    $appInfo: AppInfo!
    $companyToken: String!
    $email: String!
  ) {
    triggerLearnerVerificationEmail(
      appInfo: $appInfo
      companyToken: $companyToken
      email: $email
    ) {
      response {
        success
        email
        title
        subTitle
        pageState
      }
    }
  }
`;

export const LEARNER_UPGRADE_INDEX_SCREEN_VERSION = gql`
  mutation LearnerUpgradeIndexScreenVersion(
    $version: IndexScreenVersion!
    $appInfo: AppInfo!
    $periodLength: LearnerIndexScoreDataPeriodLength
    $startDate: Date
    $endDate: Date
  ) {
    learnerUpgradeIndexScreenVersion(version: $version, appInfo: $appInfo) {
      ok
      screen {
        version
        exercise {
          title
          subTitle
          videoUrl
          videoThumbnailUrl
          buttonText
        }
        score {
          value
          valueFloat
          labelHtml
          icon
          data(
            periodLength: $periodLength
            startDate: $startDate
            endDate: $endDate
          ) {
            periodLength
            startDate
            endDate
            dataPoints {
              date
              label
              assessmentValue
              biometricsValue
            }
          }
        }
        coach {
          name
          avatarUrl
          messageTextHtml
          assessmentButton {
            text
            url
          }
        }
        breakdown {
          energy {
            ...LearnerIndexBreakdownPillarParts
          }
          resilience {
            ...LearnerIndexBreakdownPillarParts
          }
          activity {
            ...LearnerIndexBreakdownPillarParts
          }
        }
        progress {
          title
          labels
          minValue
          maxValue
          energyData {
            label
            values
          }
          resilienceData {
            label
            values
          }
          activityData {
            label
            values
          }
        }
        biometrics {
          sessionsHistory {
            state
            callToActionTitle
            callToActionContentHtml
            callToActionButtonText
            contentList {
              __typename
              ... on LearnerGroupSessionsList {
                id
                label
                items {
                  ...LearnerSessionCardParts
                }
              }
            }
          }
        }
      }
      message
    }
  }
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_PARTS}
  ${LEARNER_SESSION_CARD_PARTS}
`;

export const LEARNER_HIDE_INDEX_SCREEN_EXERCISE = gql`
  mutation LearnerHideIndexScreenExercise($appInfo: AppInfo!) {
    learnerHideIndexScreenExercise(appInfo: $appInfo) {
      ok
      screen {
        exercise {
          title
          subTitle
          videoUrl
          videoThumbnailUrl
          buttonText
        }
      }
    }
  }
`;

export const LEARNER_BIOMETRIC_DISMISS_WEB_MODAL = gql`
  mutation LearnerBiometricsDismissWebModal($appInfo: AppInfo!) {
    learnerBiometricsDismissWebModal(appInfo: $appInfo) {
      ok
      learner {
        ...LearnerParts
        onboarding {
          ...LearnerOnboardingParts
        }
        biometrics {
          ...LearnerBiometricsParts
        }
        screens {
          index {
            version
          }
        }
      }
    }
  }
  ${LEARNER_PARTS}
  ${LEARNER_ONBOARDING_PARTS}
  ${LEARNER_BIOMETRICS_PARTS}
`;

export const LEARNER_DISMISS_INDEX_CTA_PROMPT = gql`
  mutation LearnerDismissIndexCtaPrompt($appInfo: AppInfo!, $id: ID!) {
    learnerDismissIndexCtaPrompt(appInfo: $appInfo, id: $id) {
      ok
      learner {
        id
        screens {
          index {
            CTAs {
              ...LearnerIndexCTAParts
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_CTA_PARTS}
`;

// Assessment

export const LEARNER_SUBMIT_WONE_INDEX_ASSESSMENT_RESULTS = gql`
  mutation LearnerSubmitWONEIndexAssessmentResults(
    $appInfo: AppInfo!
    $input: WONEIndexAssessmentResultsInput!
    $first: Int!
    $offset: Int!
  ) {
    learnerSubmitWoneIndexAssessmentResults(
      appInfo: $appInfo
      input: $input
      first: $first
      offset: $offset
    ) {
      ok
      learner {
        id
        screens {
          index {
            score {
              value
              valueFloat
              labelHtml
              descriptionHtml
              icon
              change {
                ...LearnerIndexScoreChangeParts
              }
              graph {
                ...LearnerIndexScoreGraphParts
              }
            }

            breakdown {
              energy {
                ...LearnerIndexBreakdownPillarV2Parts
              }
              resilience {
                ...LearnerIndexBreakdownPillarV2Parts
              }
              activity {
                ...LearnerIndexBreakdownPillarV2Parts
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_CHANGE_PARTS}
  ${LEARNER_INDEX_SCORE_GRAPH_PARTS}
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_V2_PARTS}
`;

export const REPORT_ASSESSMENT_EVENT = gql`
  mutation ReportAssessmentEvent(
    $params: JSONString
    $eventType: AssessmentEvent!
    $at: String!
    $appInfo: AppInfo!
    $groupUuid: String
  ) {
    reportAssessmentEvent(
      params: $params
      eventType: $eventType
      at: $at
      appInfo: $appInfo
      groupUuid: $groupUuid
    ) {
      ok
      groupUuid
    }
  }
`;

export const LEARNER_SUBMIT_ASSESSMENT_RESULTS = gql`
  mutation LearnerSubmitAssessmentResults(
    $appInfo: AppInfo!
    $input: AssessmentResultsInput!
    $first: Int
    $offset: Int
  ) {
    learnerSubmitAssessmentResults(
      appInfo: $appInfo
      input: $input
      first: 1
      offset: 0
    ) {
      ok
      learner {
        id
        screens {
          index {
            score {
              value
              valueFloat
              labelHtml
              descriptionHtml
              icon
              change {
                ...LearnerIndexScoreChangeParts
              }
              graph {
                ...LearnerIndexScoreGraphParts
              }
            }

            coach {
              messageTextHtml
              assessmentButton {
                text
                url
              }
              avatarUrl
            }

            breakdown {
              energy {
                ...LearnerIndexBreakdownPillarV2Parts
              }
              resilience {
                ...LearnerIndexBreakdownPillarV2Parts
              }
              activity {
                ...LearnerIndexBreakdownPillarV2Parts
              }
            }
          }
        }
        # The reply must select every schedule field the report reads, because
        # the cache merges AssessmentSchedule field by field: one left out here
        # keeps whatever an earlier assessment stored.
        assessmentSchedule {
          ...AssessmentScheduleParts
          nextCheckInBookedAt
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_CHANGE_PARTS}
  ${LEARNER_INDEX_SCORE_GRAPH_PARTS}
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_V2_PARTS}
  ${ASSESSMENT_SCHEDULE_PARTS}
`;

// Shared by both start mutations so a start over reads back exactly what a
// plain start does.
const START_ASSESSMENT_FIELDS = `
      version
      saveAndResumeSupported
      resumeStepId
      progressSavedAt
      progressExpiresAt
      steps {
        ... on AssessmentWelcomeStep {
          id
          __typename
          shorthand
          titleHtml
          subtitleHtml
        }
        ... on AssessmentSectionStep {
          id
          __typename
          shorthand
          titleHtml
          subtitleHtml
        }
        ... on AssessmentInfoStep {
          id
          __typename
          shorthand
          titleHtml
          subtitleHtml
        }
        ... on AssessmentQuestionStep {
          id
          __typename
          shorthand
          category
          domain
          titleHtml
          subtitleHtml
          input {
            __typename
            ... on TextInput {
              id
              label
              required
              type
              minLength
              maxLength
              placeholder
              min
              max
            }
            ... on SelectInput {
              id
              label
              required
              options {
                id
                label
                displayOrder
                lowerBound
                value
              }
            }
          }
          response {
            text
            score
            optionId
          }
        }
        ... on AssessmentEndStep {
          id
          __typename
          shorthand
          titleHtml
          subtitleHtml
        }
      }
`;

export const START_ASSESSMENT = gql`
  mutation StartAssessment($appInfo: AppInfo!, $version: String) {
    startAssessment(appInfo: $appInfo, version: $version) {
      ${START_ASSESSMENT_FIELDS}
    }
  }
`;

// A separate document rather than an optional variable on START_ASSESSMENT:
// that one runs for every learner, and a server without the argument would
// reject it outright.
export const START_ASSESSMENT_OVER = gql`
  mutation StartAssessmentOver($appInfo: AppInfo!, $version: String) {
    startAssessment(appInfo: $appInfo, version: $version, startOver: true) {
      ${START_ASSESSMENT_FIELDS}
    }
  }
`;

export const SAVE_AND_EXIT_ASSESSMENT = gql`
  mutation SaveAndExitAssessment(
    $appInfo: AppInfo!
    $responses: [AssessmentStepResponseInput!]!
    $stepId: ID
  ) {
    saveAndExitAssessment(
      appInfo: $appInfo
      responses: $responses
      stepId: $stepId
    ) {
      ok
    }
  }
`;

export const SAVE_ASSESSMENT_PROGRESS = gql`
  mutation SaveAssessmentProgress(
    $appInfo: AppInfo!
    $responses: [AssessmentStepResponseInput!]!
    $stepId: ID
  ) {
    saveAssessmentProgress(
      appInfo: $appInfo
      responses: $responses
      stepId: $stepId
    ) {
      ok
    }
  }
`;

export const LEARNER_ARTICLE_FEEDBACK = gql`
  mutation LearnerArticleFeedback(
    $appInfo: AppInfo!
    $input: LearnerArticleFeedbackInput!
  ) {
    learnerArticleFeedback(appInfo: $appInfo, input: $input) {
      ok
    }
  }
`;

export const LEARNER_SCHEDULE_ON_DEMAND_CALENDAR = gql`
  mutation LearnerScheduleOndemandCalendar(
    $appInfo: AppInfo!
    $recordingId: ID!
    $datetimeSlotUtc: DateTime!
  ) {
    learnerScheduleOndemandCalendar(
      appInfo: $appInfo
      recordingId: $recordingId
      datetimeSlotUtc: $datetimeSlotUtc
    ) {
      ok
      learnerRecording {
        ...LearnerRecordingParts
      }
    }
  }
  ${LEARNER_RECORDING_PARTS}
`;

export const LEARNER_DELETE_ON_DEMAND_CALENDAR = gql`
  mutation LearnerDeleteOndemandCalendar(
    $appInfo: AppInfo!
    $recordingId: ID!
  ) {
    learnerDeleteOndemandCalendar(
      appInfo: $appInfo
      recordingId: $recordingId
    ) {
      ok
      learnerRecording {
        ...LearnerRecordingParts
      }
    }
  }
  ${LEARNER_RECORDING_PARTS}
`;

export const LEARNER_ACCEPT_ORI_DISCLAIMER = gql`
  mutation LearnerAcceptOriDisclaimer($appInfo: AppInfo!, $version: String!) {
    learnerAcceptOriDisclaimer(appInfo: $appInfo, version: $version) {
      ok
      learner {
        ...LearnerParts
      }
    }
  }
  ${LEARNER_PARTS}
`;

export const RATE_ASSESSMENT_REPORT = gql`
  mutation RateAssessmentReport(
    $appInfo: AppInfo!
    $responseId: ID!
    $helpful: Boolean!
    $reportCopyStatus: AssessmentReportStatus
  ) {
    rateAssessmentReport(
      appInfo: $appInfo
      responseId: $responseId
      helpful: $helpful
      reportCopyStatus: $reportCopyStatus
    ) {
      ok
    }
  }
`;

export const OPEN_ADVENT_DOOR = gql`
  mutation OpenAdventDoor($doorId: ID!) {
    openAdventDoor(doorId: $doorId) {
      ok
      door {
        id
        isOpened
        openedAt
      }
      campaign {
        id
        openedCount
      }
    }
  }
`;

export const COMPLETE_ADVENT_DOOR = gql`
  mutation CompleteAdventDoor($doorId: ID!, $response: JSONString) {
    completeAdventDoor(doorId: $doorId, response: $response) {
      ok
      door {
        id
        isOpened
        openedAt
        isCompleted
        completedAt
        response
      }
      campaign {
        id
        openedCount
      }
    }
  }
`;

export const SEND_ADVENT_DOOR_INVITE = gql`
  mutation SendAdventDoorInvite($doorId: ID!) {
    sendAdventDoorInvite(doorId: $doorId) {
      ok
      alreadySent
      door {
        id
        invite {
          localTime
          timeZone
          durationMinutes
          sentAt
          startsAt
          delivery
        }
      }
    }
  }
`;
